import angular from 'angular';

function lwPageFooter() {
	return {
		restrict: 'E',
		transclude: true,
		template: require('./lw-page-footer.html')
	};
}
lwPageFooter.$inject = [];

export default angular.module('directives.lw-page-footer', [])
	.directive('lwPageFooter', lwPageFooter)
	.name;



// WEBPACK FOOTER //
// ./project/directives/lw-page-footer/index.js